import React from 'react';
import { Translation } from 'react-i18next';
import { Col, Row, Button, Space, Divider } from 'antd';
import { withRouter } from 'react-router';

const LearningAdminModuleFormFooter = ({
  id,
  disabled,
  module,
  htmlType = 'button',
  onClickCancel = () => {},
  onClickSave = () => {},
}) => {
  return (
    <Translation>
      {(t) => (
        <div className='learning-admin-form-footer'>
          <Divider style={{ margin: '0 auto' }} />
          <Row justify='end' align='top' style={{ marginTop: '10px' }}>
            <Col>
              <Space>
                <Button
                  htmlType={htmlType}
                  className='cancel-btn-resource'
                  onClick={onClickCancel}
                  size='large'
                  disabled={disabled}
                >
                  {t(
                    `learning_admin_form_module_button_${module}${
                      id ? '_edit' : '_add'
                    }_cancel`
                  )}
                </Button>
                <Button
                  onClick={onClickSave}
                  htmlType='submit'
                  type='primary'
                  disabled={disabled}
                  size='large'
                >
                  {t(
                    `learning_admin_form_module_button_${module}${
                      id ? '_edit' : '_add'
                    }`
                  )}
                </Button>
              </Space>
            </Col>
          </Row>
        </div>
      )}
    </Translation>
  );
};

export default withRouter(LearningAdminModuleFormFooter);
